import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Box, Typography, Link } from '@mui/material';
import Iconify from './Iconify';
import { openUrl } from '../utils/miscellaneous';

ResumeInfo.propTypes = {
  iconify: PropTypes.any,
  iconBgColor: PropTypes.any,
  iconColor: PropTypes.any,
  iconSize: PropTypes.number,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  link: PropTypes.string,
  url: PropTypes.string,
  sx: PropTypes.object,
  nodeEnd: PropTypes.any,
};

export default function ResumeInfo({
  iconify = '',
  iconBgColor = '',
  iconColor = 'text.secondary',
  iconSize = 14,
  title = '',
  subtitle = '',
  link = '',
  url,
  sx,
  nodeEnd,
  onClick = () => {},
  ...other
}) {
  const IconBlock = (
    <Box
      sx={{
        ...(iconBgColor
          ? {
              width: 14,
              height: 14,
              flexShrink: 0,
              display: 'flex',
              borderRadius: 1.5,
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: (theme) => theme.customShadows.z24,
            }
          : {}),
        color: (theme) => theme.palette.grey[500],
        paddingTop: '3px',
      }}
    >
      <Iconify width={iconSize} height={iconSize} icon={iconify} />
    </Box>
  );
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        ...sx,
      }}
      onClick={() => {
        if (url) {
          openUrl(url);
        } else {
          onClick();
        }
      }}
      {...other}
    >
      {iconify && IconBlock}
      <Box sx={{ flexGrow: 1, minWidth: 80, ml: 2 }}>
        {title && (
          <Typography
            variant="body3"
            sx={{
              color: (theme) =>
                theme.palette.mode === 'light'
                  ? theme.palette.grey[900]
                  : theme.palette.common.white,
              cursor: 'pointer',
            }}
          >
            {title}
          </Typography>
        )}
        <Stack direction="column" sx={{ color: 'text.secondary' }}>
          {subtitle && (
            <Typography
              variant="body3"
              sx={{
                fontWeight: 400,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              {subtitle}
            </Typography>
          )}
          {link && (
            <Link
              variant="caption"
              sx={{
                'textDecoration': 'underline',
                'color': (theme) => theme.palette.secondary.main,
                '&:hover': {
                  cursor: 'pointer',
                },
              }}
              onClick={() => {
                if (url) {
                  openUrl(url);
                }
              }}
            >
              {link}
            </Link>
          )}
        </Stack>
      </Box>
      {nodeEnd && <>{nodeEnd}</>}
    </Stack>
  );
}
